// Shopify Theme JavaScript

(function() {
  'use strict';

  // Cart Functionality
  const cartCount = document.querySelector('.cart-count');

  // Update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Add to cart
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        updateCartCount();
        alert('Ürün sepete eklendi!');
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert('Bir hata oluştu.');
      });
    });
  });

  // Initialize
  if (cartCount) {
    updateCartCount();
  }

  // Mobile menu toggle (if needed)
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.site-nav');

  if (menuToggle) {
    menuToggle.addEventListener('click', function() {
      mobileNav.classList.toggle('is-open');
    });
  }

})();
